'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconSquareT, iconSquareTTag } from '@ni/nimble-components/dist/esm/icons/square-t';
import { wrap } from '../../utilities/react-wrapper';

export type { IconSquareT };
export { iconSquareTTag };
export const NimbleIconSquareT = wrap(IconSquareT);